import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import colors from "stylesheets/utilities/colors.scss";

import LoginSplash from "components/Common/LoginSplash";

export default class MFAConfirmation extends PureComponent {
  /**
   * @returns {HTMLObjectElement}
   */
  render() {
    const { onClick, currentStep } = this.props;

    if (currentStep !== 4) {
      return null;
    }

    const description = (
      <span>
        Two-Factor authentication has been successfully enabled for your account.
        <br />
        <br />
        Whenever you sign in to Ada, you&#39;ll need to enter a verification code from your phone.
      </span>
    );

    return (
      <LoginSplash
        title="Multi-Factor Authentication"
        button={{
          label: "Continue to Ada",
          action: () => onClick()
        }}
        description={description}
        icon="CircleCheckmark"
        fillColor={colors.colorUIGood}
      />
    );
  }
}

MFAConfirmation.propTypes = {
  onClick: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired
};
